import { useEffect, useState } from 'react';
import { ModalProps } from '../../../../../../components/modal/modal';
import { validate } from '../../../../../../helpers/validate';
import { useLang } from '../../../../../../hooks/use-lang';
import { CreateExternalReviewRequest, fetchAvailableResources } from '../../../../../../store/api/external-reviews-api';
import { useAlertStore } from '../../../../../../store/use-alert-store';
import { useExternalReviewsStore } from '../../../../../../store/use-external-reviews-store';
import { getSourceInfo, normalizeSourceName } from './helpers';

export const useCreateExternalReviewModal = (props: ModalProps) => {
  const { t } = useLang();
  const { createExternalReview, isLoadingAction } = useExternalReviewsStore();

  const [formData, setFormData] = useState<Partial<CreateExternalReviewRequest & { profile_url: string }>>({
    resource_id: 0,
    profile_url: '',
    repeat_per_day: 1,
  });

  const [availableResources, setAvailableResources] = useState<
    { id: number; name: string; type?: string }[]
  >([]);
  const [detectedSource, setDetectedSource] = useState<{ name: string; icon: string } | null>(null);

  useEffect(() => {
    fetchAvailableResources().then(setAvailableResources).catch(console.error);
  }, []);

  const resetForm = () => {
    setFormData({
      resource_id: 0,
      profile_url: '',
      repeat_per_day: 1,
    });
    setDetectedSource(null);
  };

  const handleUrlChange = (url: string) => {
    setFormData((prev) => ({ ...prev, profile_url: url }));

    if (url) {
      const sourceInfo = getSourceInfo(url);
      if (sourceInfo) {
        setDetectedSource(sourceInfo);
        const resource = availableResources.find(
          (item) => normalizeSourceName(item.name) === normalizeSourceName(sourceInfo.name),
        );
        setFormData((prev) => ({ ...prev, resource_id: resource?.id || 0 }));
      } else {
        setDetectedSource(null);
        setFormData((prev) => ({ ...prev, resource_id: 0 }));
      }
    } else {
      setDetectedSource(null);
      setFormData((prev) => ({ ...prev, resource_id: 0 }));
    }
  };

  const handleSubmit = async () => {
    const isValid = validate({
      profile_url: { rule: () => !!formData.profile_url && formData.profile_url.length > 0 },
      resource_id: { rule: () => !!formData.resource_id && formData.resource_id > 0 },
      repeat_per_day: { rule: () => !!formData.repeat_per_day && formData.repeat_per_day > 0 },
      // place_id опционален, поэтому не валидируем
    });

    if (!formData.resource_id || formData.resource_id <= 0) {
      useAlertStore
        .getState()
        .add({ label: 'Ресурс не определен по ссылке', variant: 'danger' });
      return;
    }
    if (!isValid) return;

    try {
      await createExternalReview({
        resource_id: formData.resource_id!,
        profile_url: formData.profile_url!,
        repeat_per_day: formData.repeat_per_day!,
      });
      resetForm();
      props.onClose();
    } catch (e) {
      // Ошибка обрабатывается в store
    }
  };

  return {
    t,
    formData,
    setFormData,
    availableResources,
    detectedSource,
    handleUrlChange,
    handleSubmit,
    isLoading: isLoadingAction,
  };
};
